import React, { useRef } from "react";
import "./contactForm.scss";

import emailjs from "@emailjs/browser";

const ContactForm = () => {
  // const [errprMessage, setErrorMessage] = useState(false);

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_sma9f35",
        "template_c22ib8l",
        form.current,
        "F0oGKHvX6vmJNapRU"
      )
      .then(
        (result) => {
          // console.log(result.text);
          alert("Email Sent, I will get back to you shortly", result.text);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          e.target.reset();
          //   alert("Email Sent, I will get back to you shortly");
        }
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail} className="contact__form ">
      <div className="contact__form-div">
        <label htmlFor="" className="contact__form-tag">
          Name
        </label>
        <input
          type="text"
          name="name"
          placeholder="Name"
          className="contact__form-input"
          required
        />
      </div>

      <div className="contact__form-div">
        <label htmlFor="" className="contact__form-tag">
          Email
        </label>
        <input
          type="email"
          name="email"
          placeholder="Email"
          className="contact__form-input"
          required
        />
      </div>

      <div className="contact__form-div contact__form-area">
        <label htmlFor="" className="contact__form-tag">
          Message
        </label>
        <textarea
          name="message"
          id=""
          cols="30"
          rows="10"
          className="contact__form-input"
          placeholder="Your Project"
          required
        ></textarea>
      </div>

      <button type="submit" value="Send" className="contactForm__btn">
        Send Message
      </button>
    </form>
  );
};

export default ContactForm;
